import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { NotificationType } from './notification-types';

const notificationsAdapter = createEntityAdapter<
  { id: string } & NotificationType
>();

export const notificationsSelectors = notificationsAdapter.getSelectors();

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    ids: [],
    entities: {},
  },
  reducers: {
    createNotification(
      state,
      action: PayloadAction<NotificationType & { id: string }>,
    ) {
      notificationsAdapter.addOne(state, action.payload);
    },

    removeNotification(state, action: PayloadAction<{ id: string }>) {
      notificationsAdapter.removeOne(state, action.payload.id);
    },
  },
});

export const notificationsReducer = notificationsSlice.reducer;
export const { createNotification, removeNotification } = notificationsSlice.actions;
